import { render, staticRenderFns } from "./back-overseasreturnhandle.vue?vue&type=template&id=3b6f3e03&scoped=true&"
import script from "./back-overseasreturnhandle.vue?vue&type=script&lang=ts&"
export * from "./back-overseasreturnhandle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6f3e03",
  null
  
)

export default component.exports